import { AccessLevelEnum } from '@zaoblako/shared/modules/security/enums/access.level.enum';
import { DebtsAccessRulesKeyEnum } from '@zaoblako/web/core/models/enums/access-rules/debts/debts-access-rules-key.enum';

type AccessRuleExpression = Record<string, any>;

export const DebtsAccessRulesConst: Record<DebtsAccessRulesKeyEnum, AccessRuleExpression> = {
  // --- Модуль DEBTS (Задолженности) ---
  // --- Раздел DEBTS.SECTIONS.DEBTS (Задолженности) ---

  // Вкладки
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBTORS_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.DEBTORS.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.CREDIT.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBIT_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.DEBIT.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_BILL_REGISTRY_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.BILL_REGISTRY.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_AUTOCHECK_BILLS_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.AUTOCHECK_BILLS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_MAILING_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.MAILING.enabled': true,
    'DEBTS.sections.DEBTS.tabs.MAILING.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_MAILING_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.MAILING.enabled': true,
    'DEBTS.sections.DEBTS.tabs.MAILING.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CASH_GAP_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.CASH_GAP.enabled': true,
    'DEBTS.sections.DEBTS.tabs.CASH_GAP.accessLevel': { $gte: AccessLevelEnum.READ }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.CREDIT_DEBIT_EXCLUSION.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_CREDIT_DEBIT_EXCLUSION_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.CREDIT_DEBIT_EXCLUSION.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.DEBT_COLLECTION.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.DEBT_COLLECTION.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_EMAIL_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.INTEGRATION_EMAIL.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_EMAIL_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.INTEGRATION_EMAIL.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_MAIN_SMS_READ]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.INTEGRATION_MAIN_SMS.accessLevel': { $gte: AccessLevelEnum.READ }
  },
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_INTEGRATION_MAIN_SMS_WRITE]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.tabs.INTEGRATION_MAIN_SMS.accessLevel': { $gte: AccessLevelEnum.WRITE }
  },

  // Разрешения
  [DebtsAccessRulesKeyEnum.DEBTS_DEBTS_DEBT_COLLECTION_READ_ALL_TASKS]: {
    'DEBTS.enabled': true,
    'DEBTS.sections.DEBTS.permissions.DEBT_COLLECTION_READ_ALL_TASKS.isAllowed': true
  }
};
